const localeConfig = [
    /**
     * TODO: 추후에 DB에서 관리하게 될 수도 있음
     * 
     * localeNum: 나라(또는 로케일)에 할당된 고유한 숫자 코드 (ISO 3166-1 numeric 코드 기반)
     * korNm: 한국어 국가명
     * enNm: 영어 국가명
     * langCode: 언어 코드 (ISO 639-1 표준)
     * localeCode: 국가 또는 지역(ISO 3166-1 alpha-2 표준)
     * isUse: true/false (다국어 사용 국가 여부)
     * useLangCode: 사용중인 언어 코드 
     * lngLat: Mapbox(맵박스)에서 데이터가 없을 시 보여주는 지도 중심점 경도/위도 값 기본 세팅 [경도, 위도]
     */
    {"localeNum":410, "korNm":"대한민국", "enNm":"Korea,  Republic of", "langCode":"kr", "localeCode":"KR", "isUse":true, "useLangCode":"ko", "timeZone": "Asia/Seoul", "gmt": "GMT+9", "utc": "UTC+9:00", "localeNmByLang": "대한민국", "lngLat": [126.9780, 37.5665]},
    {"localeNum":496, "korNm":"몽골", "enNm":"Mongolia", "langCode":"mn", "localeCode":"MN", "isUse":true, "useLangCode":"en", "timeZone": "Asia/Ulaanbaatar", "gmt": "GMT+8", "utc": "UTC+8:00", "localeNmByLang": "Монгол", "lngLat": [106.9153, 47.9219]}
]

export default localeConfig